module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-EMR.88b9355e.png";